import { render, staticRenderFns } from "./PressReleases.vue?vue&type=template&id=40521d72&scoped=true"
import script from "./PressReleases.vue?vue&type=script&lang=js"
export * from "./PressReleases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40521d72",
  null
  
)

export default component.exports